module.exports = __webpack_public_path__ + "assets/images/sorpa.229411a772058396ad056f6213e9ea8e.svg";